module.exports = __webpack_public_path__ + "static/media/blueHatBeaver.0bcd3d51.png";